import React from 'react';
import './Editable.css';
import {Editable, EditableProps} from "./Editable";
import {PhotoUpload} from "../input/PhotoUpload";
import {useEditable} from "./EditableContext";

export const EditablePhotoUpload = <EnclosingType extends object>(props: EditableProps<EnclosingType, string>) => {

  const {editing, value, setValue} = useEditable(props);

  return <Editable {...props}>
    {editing && <PhotoUpload locationName={undefined}
                             imageUrl={value}
                             onChange={setValue}/>}

    {!editing && value &&
        // Show the image, not editable
        <div className={'PhotoUploadSinglePhoto'}>
          <img className={'PhotoUploadPhoto'} src={value ?? undefined} alt="Uploaded content"/>
        </div>
    }
  </Editable>
}